import { t } from './../../libraries/i18n';

export const forgotPasswordTitle = () => t('auth.forgot_password_title');
export const forgotPasswordSubmit = () => t('auth.forgot_password_submit_button');
export const forgotPasswordSuccess = () => t('auth.forgot_password_success');
export const usernamePlaceholder = () => t('auth.username_placeholder');
export const linkToLogin = () => t('auth.link_to_login');
